module.exports = __webpack_public_path__ + "static/media/popeye-hovered.748ff058.svg";